/**
 * Console logger for vendored plugin code.
 *
 * Replaces the plugin's internal debug-gated logger — the portal is an
 * application, so warn/error always surface while verbose levels stay behind
 * the Vite dev flag.
 *
 * SECURITY: never pass secret material (AES keys, plaintext balances,
 * ciphertext, signatures) to this logger.
 */

const isVerbose = (): boolean => import.meta.env.DEV;

export const logger = {
  log: (...args: unknown[]) => {
    if (isVerbose()) console.log(...args);
  },
  info: (...args: unknown[]) => {
    if (isVerbose()) console.info(...args);
  },
  debug: (...args: unknown[]) => {
    if (isVerbose()) console.debug(...args);
  },
  warn: (...args: unknown[]) => console.warn(...args),
  error: (...args: unknown[]) => console.error(...args),
};
